import React from "react";
import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./common/styles/global.scss";
import Main from "./pages/Main";

const App = () => <Main />;

export default App;
